module.exports = __webpack_public_path__ + "png/angle-down.png?d3a2cd9398d8f0581b99b574793803a9";